import { useTranslation } from 'react-i18next';
import CheckBox from '@components/CheckBox';

type Props = {
  onChange: (payload: { valid: boolean; value: boolean }) => void;
  payload: any;
};

const PollConfig = ({ onChange, payload }: Props) => {
  const { t } = useTranslation();
  return (
    <CheckBox
      value={payload.skipPollEnabled}
      onChange={(value: boolean) => onChange({ valid: true, value })}
      label={t('PollBuilder.skipPollEnabled')}
    />
  );
};

export default PollConfig;
